import React from 'react'
import styles from './IconNetworkNotification.module.scss'

export default function IconNetworkNotification() {
    return <div className={styles.root} />
}
